export default "__VITE_ASSET__zcZon_yv__"